/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Početak',
	myContent: 'Moj sadržaj',
	teamContent: 'Timski sadržaj',
	folder: 'Folder',
	files: 'Datoteke',
	actionMenu: 'Izbornik akcija',
	myFolder: 'Moji folderi',

	emptyFolderNoContent: 'Nema sadržaja',

	//EmptyStates
	emptyRecentTitle: 'Nedavno niste gledali sadržaj.',
	emptyStateTitle: 'Započnite s dodavanjem podataka',
	emptyStateBody: 'Kliknite gore Upload podataka ili podatke povucite i ispustite.',
	emptySearchResultTitle: 'Hm, vaše pretraživanje nije vratilo nijedan rezultat.',
	emptyPortalTitle: 'Nema portala',
	emptyPortalBody: 'Trenutno nemate nijedan portal.',
	emptyWsProjectTitle: 'Započnite s kreiranje bilježnice u Watson Studiu.',
	emptyWsProjectBody: 'Kad se vratite u Cognos Analytics, vaša bilježnica pojavit će se ovdje.',
	emptyFilteredResultTitle: 'Hmm, primijenjeni filteri nisu vratili nijedan rezultat.',
	emptyDialogViewTitle: 'Nema stavki',
	removeFromRecents: 'Ukloni iz nedavnog',

	// Welcome Banner
	welcomeBannerGreeting: 'Dobar dan. Dobro došli u Cognos Analytics.',
	welcomeBannerDescription: 'Cognos Analytics korisnicima nudi mogućnosti AI analitike na bazi samoposluživanja. Pogledajte kako automatizirana priprema podataka, otkrivanje podataka i vizualizacije mogu dovesti do sigurnijih odluka.',
	welcomeBannerDescription_trialUser: 'Možete započeti odmah s našim uvodnim video prikazom, razgledavanjem proizvoda i karticom Kako započeti.',
	takeTourButtonLabel: 'Razgledajte proizvod',
	watchVideoButtonLabel: 'Pogledajte video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Jeste li sigurni da želite isključiti uvodnik dobrodošlice na početnoj stranici? Možete ga ponovno uključiti na kartici Profil i postavke > Postavke > Opće kad god želite. ',
	hideWelcomeBannerTitle: 'Isključi uvodnik dobrodošlice',
	ok: 'OK',
	cancel: 'Opoziv',
	//howto video dialog
	modal_how_title: 'Video prikazi Kako učiniti',
	modal_overview_title: 'Pogledajte Cognos Analytics pregled',
	modal_how_play: 'Izvedi video',
	modal_how_video_title_overview: 'Pregled',
	modal_how_video_title_getStarted: 'Kako započeti u 11.2',
	modal_how_video_title_newUI: 'Dobro došli u novi Cognos prikaz',
	modal_how_video_title_dataModule: 'Pregled modula podataka',
	modal_how_video_title_explore: 'Pregled istraživanja podataka',
	modal_how_video_title_dashboard: 'Pregled interaktivnih kontrolnih ploča',
	modal_how_video_title_reporting: 'Pregled izvještavanja',
	modal_how_video_title_mobile: 'Snaga Cognosa na dlanu',

	// Toolbar
	search: 'Traži',
	addFolder: 'Dodaj folder',
	addLink: 'Dodaj vezu',
	filter: 'Filter',
	sort: 'Sortiraj',
	settings: 'Postavke',
	tilesView: 'Pogled supodručja',
	listView: 'Pogled liste',
	columnView: 'Pogled stupca',

	// Toolbar Actions
	sortBy: 'Sortiraj po',
	sortOrder: 'Poredaj',
	name: 'Naziv',
	modifiedTime: 'Promijenjeno',
	type: 'Tip',
	ascending: 'Uzlazno',
	descending: 'Silazno',

	filterType: 'Tip',
	filterModificationTime: 'Promijenjeno',
	all: 'Sve',
	today: 'Danas',
	yesterday: 'Jučer',
	pastWeek: 'Prošli tjedan',
	pastMonth: 'Prošli mjesec',
	resetFilters: 'Resetiraj filtere',

	filterSearchPlaceHolder: 'Filtriraj po ključnim riječima',

	resetFilterTag: 'Kliknite X za resetiranje filtera.',
	filterTagToolTip: 'Primijenjeni filteri: %{appliedFilters}.',

	folderName: 'Naziv foldera',
	addAFolder: 'Dodajte folder',
	add: 'Dodaj',
	error: 'Greška',
	newFolderDefaultName: 'Novi folder',
	toastCreateNewFolder: '%{nameOfFolder} folder je kreiran u  %{tabName}.',
	folderAdded: 'Folder je dodan',
	refresh: 'Osvježi',
	openFolder: 'Otvori folder',

	addAUrl: 'Dodajte URL',
	linkName: 'Naziv URL-a',
	linkNamePlaceholder: 'Dodaj naziv URL-a',
	linkDescription: 'Opis (neobavezno)',
	linkDescriptionPlaceholder: 'Dodajte opis',
	linkUri: 'URL',
	linkUriPlaceholder: 'Dodajte URL s prihvatljivom domenom',
	acceptableDomains: 'Prihvatljive domene',
	viewAcceptableDomains: 'Pregled prihvatljivih domena',
	mandatoryField: 'Obavezno polje',
	linkAdded: 'URL je dodan',
	toastCreateNewLink: '%{nameOfLink} je dodana u %{tabName}.',
	noEntries: 'Ne postoje unosi u listi prihvatljivih domena. Kontaktirajte vašeg administratora.',

	compact: 'Kompaktan',
	short: 'Kratki',
	default: 'Default',
	rowSize: 'Veličina reda',

	// GroupyByTypes
	folders: 'Folderi',
	reports: 'Izvještaji',
	dashboards: 'Kontrolne ploče',
	data: 'Podaci',
	packages: 'Paketi',
	explorations: 'Istraživanja',
	stories: 'Priče',
	notebooks: 'Bilježnice',
	others: 'Ostalo',

	// Error Messages
	itemsOverLimit: 'Navedeni naziv "%{itemName}" premašio je ograničenje maksimalne duljine (20). Molim, navedite različiti naziv da možete nastaviti.',
	errorMessageLengthFolderName: 'Molim, unesite naziv foldera koji ne prelazi 255 znakova.',
	errorMessageLengthLinkName: 'Molim, unesite naziv poveznice koji ne prelazi 255 znakova.',
	toastLaunchPerspectiveError: 'Ne može se otvoriti %{objectType}.',
	errorNoAccessTitle: 'Oh, izgleda da nemate pravo pristupa ovom sadržaju',
	errorNoAccessBody: 'Kontaktirajte svog administratora ili pogledajte sljedeću poveznicu:',
	errorEnableExternalContent: 'Omogućavanje vanjskog sadržaja',

	//TableHeader
	lastModified: 'Zadnja promjena',
	location: 'Lokacija',
	tenant: 'Zakupac',

	// GetStartedTab
	getStartedLabel: 'Kako započeti i raditi u IBM Cognos Analytics',
	learningHowToLabel: 'Resursi za učenje',
	learningHowToDescription: 'Proširite svoje znanje i pronađite pomoć putem povezivanja sa zajednicom, čitanjem dokumentacije i gledanjem video prikaza.',
	learningHowToActionLabel: 'Pokreni okvir za učenje',
	howToVideosLabel: 'Video prikazi \'kako učiniti\'',
	howToVideosDescription: 'Naučite koristiti IBM Cognos Analytics i započnite stjecati uvid u svoje podatke.',
	howToVideosActionLabel: 'Pogledajte video prikaze',
	acceleratorCatalogLabel: 'Accelerator katalog',
	acceleratorCatalogDescription: 'Pregledajte rastući katalog industrijske upotrebe, vodiče za najbolje postupke, prilagođene vizualizacije i više toga.',
	acceleratorCatalogActionLabel: 'Pregled kataloga',
	sampleSectionTitle: 'Primjeri',
	sampleSectionDescription: 'Eksperimentirajte s primjerima koji pokazuje sve što Cognos Analytics može ponuditi.',
	// Samples Section
	createDashboardSampleTitle: 'Kako kreirati prvu kontrolnu ploču',
	createDashboardSampleDescription: 'Započnite svoje putovanje kroz analitiku s Cognos kontrolnim pločama.',
	covid19SampleTitle: 'COVID kontrolna ploča',
	covid19SampleDescription: 'Istražite umjetnost mogućeg s Cognos kontrolnom pločom koja analizira podatke vezane uz COVID-19 i prilagođena proširenja.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Proširite svoju knjižnicu vizualizacija s prilagođenim vizualizacijama poput Sankey grafikona.',
	viewAllSamplesActionLabel: 'Pregled svih primjera',
	byFeatureTitle: 'Po funkciji',
	byFeatureDescription: 'Pregledajte primjere po funkcijama kao što su osnovna funkcionalnost, prilagođene kontrole, proširenja, bilježnice i relativni datumi.',
	byIndustryTitle: 'Po djelatnosti',
	byIndustryDescription: 'Pregledajte primjere po djelatnostima kao što su automobilska industrija, bankarstvo i drugo.',
	// SamplesTab
	sampleTabTitle: 'Koristite predizgrađene primjere za nove ideje',
	sampleTabLabel: 'Posjetite Accelerator katalog za više primjera i proširenja od IBM-a, partnera i korisnika',

	// quickLaunch
	quickLaunchLabel: 'Brzo pokretanje',
	expand: 'Proširi',
	collapse: 'Skupi',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Započnite s izbornom onog što želite kreirati.',

	// contentPageView
	contentPageTitleLabel: 'Sadržaj',
	uploadFile: 'Upload podataka',
	new: 'Novo',
	create: 'Kreiraj',
	more: 'Više',

	// open dialog
	selectDataSourcesToAdd: 'Izaberite izvor(e) podataka koji(e) ćete dodati.',
	openDialogDefaultTitle: 'Otvori',

	// save dialog
	save: 'Spremi',
	saveAs: 'Spremi kao',
	saving: 'Spremanje...',
	selectedDestination: 'Izabrano odredište: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' već postoji kao različiti tip. Molim, izaberite različiti naziv.',
	confirmOverwriteTitle: 'Potvrdi zamjenu postojećih podataka',
	confirmOverwriteMsg: 'Datoteka \'%{nameOfFile}\' već postoji. Želite li zamijeniti njezine podatke s podacima iz izabrane datoteke?',

	// copy move dialog
	copy: 'Kopiraj',
	move: 'Premjesti',
	copyOrMove: 'Kopiraj ili premjesti: ',
	copyOnly: 'Kopiraj ',
	createShortcut: 'Kreiraj prečicu',
	createShortcutDialogTitle: 'Kreiraj prečicu: ',

	// External asset types
	wsProject: 'Watson Studio projekt',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Paket',
	dataModule: 'Modul podataka',
	exploration: 'Istraživanje',
	mode: 'Način',
	live: 'Uživo',
	snapshot: 'Snimka',
	noSnapshotsFound: 'Snimka nije nađena',
	uploadedFile: 'Uploadana datoteka',
	fileUpload: 'Upload podataka',
	dataSetEx: 'Skup podataka',
	externalRepository: 'Vanjsko spremište',
	queryMode: 'Način upita',
	queryModeCompatible: 'Kompatibilno',
	queryModeDynamic: 'Dinamički',
	report: 'Izvještaj',
	activeReport: 'Aktivni izvještaj',
	query: 'Upit',
	analysis: 'Analiza',
	dashboard: 'Kontrolna ploča',
	dashboardTemplate: 'Predložak kontrolne ploče',
	jupyterNotebook: 'Bilježnica',
	wsNotebook: 'Watson Studio bilježnica',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Priča',
	workspace: 'Radni prostor',
	pagelet: 'Stranica',
	content: 'Sadržaj',
	directory: 'Imenski prostori',
	dataSet: 'Skup podataka',
	powerPlayCube: 'PowerPlay kocka',
	powerPlayReport: 'PowerPlay izvještaj',
	powerPlay8Report: 'PowerPlay izvještaj',
	powerPlay8ReportView: 'PowerPlay pogled izvještaja',
	reportTemplate: 'Predložak izvještaja',
	packageConfigurations: 'Konfiguracija paketa',
	agent: 'Agent',
	agentDefinition: 'Definicija agenta',
	agentDefinitionView: 'Pogled agenta',
	dataMovementTask: 'Zadatak premještanja podataka',
	dataMovementTaskAlias: 'Zamjensko ime zadatka premještanja podataka',
	document: 'Dokument',
	DocumentRetention: 'Svojstva dokumenta',
	jobDefinition: 'Definicija posla',
	job: 'Posao',
	metricsDataSourceETLTask: 'Zadatak ETL izvora podataka metrika',
	metricsExportTask: 'Zadatak Eksport metrika',
	metricsFileImportTask: 'Zadatak Import datoteke metrika',
	metricsMaintenanceTask: 'Zadatak Održavanje metrika',
	planningTask: 'Zadatak Planiranje',
	shortcut: 'Prečica',
	URL: 'URL',
	launchable: 'Može se pokrenuti',
	dataSetFolder: 'Folder skupa podataka',
	ViewAccessibleLabel: 'Pregled %{label}',
	overrideReportOptions: 'Nadjačaj default opcije izvještaja',
	formats: 'Formati',
	saveReport: 'Spremi izvještaj',
	promptForValues: 'Pitaj me',
	reportView: 'Pogled izvještaja',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel podaci',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Detalji',
	open: 'Otvori',
	created: 'Kreirano',
	modified: 'Promijenjeno',
	owner: 'Vlasnik',
	dataSource: 'Izvor podataka',
	share: 'Dijeli',
	addToFavorites: 'Dodaj u favorite',
	properties: 'Svojstva',
	detailsEmptyStateBody: 'Izaberite stavku da pogledate njene detalje',
	editNameAndDescription: 'Uredi naziv i opis',
	none: 'Nijedan',

	//rename dialog
	nameInvalid: 'Naziv nije ispravan',
	namePlaceholder: 'Unesite naziv',
	description: 'Opis',
	descriptionInvalid: 'Opis ne može biti dulji od 350 znakova.',
	descriptionPlaceholder: 'Unesite opis',
	errorMessageApostropheError: 'Molim, unesite naziv datoteke koja istodobno ne sadrži znakove \' i "',
	renameCollisionError: '%{name} već postoji. Pokušajte s različitim nazivom.',
	unknownRenameError: 'Preimenovanje stavke nije uspjelo. Kontaktirajte administratora za dodatnu pomoć.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Ne može se otvoriti navedeni folder.',

	//Upload
	uploadToFolder: "Uploadaj u <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Uploadaj u <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> i pokreni %{launchAction}",
	quickUpload: "Brzi upload",
	quickUploadAndLaunch: "Povucite i ispustite datoteke da ih uploadate u <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> i otvorite u jednom od sljedećih prostora.",
	unsupportedFilesSingle: "%{files} nije uploadana jer nije važeća za Brzo pokretanje.",
	unsupportedFilesMultiple: "Datoteke nisu uploadane jer sve datoteke koje izaberete moraju biti važeće za korištenje brzog pokretanja.",
	unsupportedFilesSingleInvalid: "%{files} nije važeća.",
	unsupportedFilesMultipleInvalid: "%{files} nisu važeće.",
	supportedFileTypes: "Dozvoljeni su samo sljedeći tipovi datoteka: %{extensions}.",
	uploadDragAndDrop: "Povuci i ispusti",
	uploadDragAndDropMessage: "Povucite i ispustite svoju datoteku ovdje kako biste ju uploadali u <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Kriteriji pretraživanja \'%{searchTerm}\' su spremljeni.',
	searchWasntSaved: 'Kriteriji pretraživanja \'%{searchTerm}\' nisu spremljeni.',
	searchSuggestions: 'Prijedlozi',
	savedSearch: 'Spremljena pretraživanja',
	searchWasDeleted: 'Kriteriji pretraživanja \'%{searchTerm}\' su izbrisani.',
	searchWasntDeleted: 'Kriteriji pretraživanja \'%{searchTerm}\' nisu izbrisani.',
	savedBarTitle: 'Pretraži Cognos Analytics',
	searchContentPageTitle: 'Traži',
	searchContentPageTitleLabel: 'Prikaz rezultata za \'%{searchTerm}\'',
	showingSearchRsult: 'Prikaz %{resultCount} stavki',
	saveSearch: 'Spremi pretraživanje',
	saveTenSearches: 'Možete spremiti 10 pretraživanja.',
	deleteASearch: 'Izbrišite jedno da spremite drugo.',
	close: 'Zatvori',

	//recent view
	recents: 'Nedavno',
	noAccessRecent: 'Nema pristupa',
	noAccessRecentMsg: 'Nemate pravo pristupa ovom sredstvu. Možda je onemogućeno ili izbrisano ili su vaše dozvole smanjene. Provjerite stanje sredstva na očekivanoj izvornoj lokaciji. Možete ukloniti sredstvo iz liste nedavnih stavki klikom na OK.',
	noAccessMsg: 'Nemate pravo pristupa ovom sredstvu. Možda je onemogućeno ili izbrisano ili su vaše dozvole smanjene.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} stavki izabrano',
	itemSelected: '%{nameOfSelection} stavka izabrana'

});